import React, { lazy } from 'react';
import { ArrowRight, Star, ShieldCheck, Flame } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function PricingSection() {
  return <section id="offer" className="bg-pilates-blue-dark py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden border-t border-pilates-lavender" data-id="element-156">
      {/* Stadium light radial */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[radial-gradient(circle,rgba(201,166,107,0.15)_0%,transparent_70%)] pointer-events-none" data-id="element-157"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-158">
        <div className="border border-pilates-lavender text-pilates-lavender font-semibold text-xs px-4 py-1.5 mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-159">
          SPECIAL OFFER — COMPLETE 6-IN-1 BUNDLE
        </div>
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-white leading-tight mb-4 tracking-tight" data-id="element-160">
          Access the system now and transform your practices{' '}
          <span className="italic text-pilates-lavender" data-id="element-161">starting today</span>
        </h2>

        <div className="mb-8 max-w-md mx-auto mt-10" data-id="element-162">
          <img src="https://cdn.magicpatterns.com/uploads/3BeFdoayiknhsrXtc74pGh/image_(3).webp" alt="VolleyReady 6-in-1 Bundle" className="w-full rounded-lg shadow-2xl border border-white/10" loading="lazy" decoding="async" width="800" height="800" data-id="element-163" />
        </div>

        <div id="pricing-card" className="bg-white rounded-lg p-6 sm:p-8 shadow-2xl max-w-md mx-auto scroll-mt-8 border-t-4 border-pilates-lavender" data-id="element-164">
          <p className="text-pilates-slate text-sm mb-1" data-id="element-165">
            Regular Price: <span className="line-through" data-id="element-166">$97 USD</span>
          </p>

          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-pilates-rose to-pilates-rose-dark text-white text-xs font-bold px-3 py-1.5 rounded-sm my-3 uppercase tracking-wide border border-pilates-rose-dark" data-id="element-167">
            <Flame className="w-4 h-4" data-id="element-168" /> 72% OFF — Launch Offer
          </div>

          <p className="text-pilates-slate text-sm mb-1" data-id="element-169">One-time payment:</p>
          <p className="font-display text-6xl sm:text-7xl font-semibold text-pilates-blue-dark mb-0 leading-none flex items-start justify-center" data-id="element-170">
            <span className="text-3xl sm:text-4xl text-pilates-lavender mt-1 mr-1" data-id="element-171">
              $
            </span>
            27
            <span className="text-2xl sm:text-3xl text-pilates-lavender mt-2 ml-1.5" data-id="element-172">
              USD
            </span>
          </p>
          <p className="text-pilates-slate text-[10px] mb-4 uppercase tracking-wider" data-id="element-173">
            Instant Access — 100% Secure
          </p>

          <p className="text-pilates-rose font-bold text-sm mb-5 flex items-center justify-center gap-1 uppercase tracking-wide" data-id="element-174">
            <Flame className="w-4 h-4" data-id="element-175" /> Only 23 copies left at this discounted
            price!
          </p>

          <div className="mb-6" data-id="element-176">
            <CountdownTimer data-id="element-177" />
          </div>

          <a href="https://volley-ready.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="group w-full bg-gradient-to-r from-pilates-rose to-pilates-rose-dark text-white font-semibold text-base sm:text-lg py-4 px-6 rounded-lg border-t border-white/20 shadow-[0_10px_30px_rgba(192,57,43,0.4)] hover:shadow-[0_15px_40px_rgba(192,57,43,0.6)] hover:-translate-y-1 transition-all duration-300 flex items-center justify-center gap-3" data-id="element-178">
            <span data-id="element-179">🏐 I WANT MY 6-IN-1 BUNDLE ($27 USD)</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-180" />
          </a>

          <div className="mt-5 flex flex-col items-center gap-2" data-id="element-181">
            <div className="flex items-center gap-2" data-id="element-182">
              <div className="flex text-pilates-lavender" data-id="element-183">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-184" />)}
              </div>
              <span className="text-pilates-slate text-sm font-medium" data-id="element-185">
                4.9/5 — Verified Reviews
              </span>
            </div>
            <div className="flex items-center gap-2 text-pilates-slate text-sm" data-id="element-186">
              <ShieldCheck className="w-4 h-4 text-pilates-blue-dark" data-id="element-187" />
              <span data-id="element-188">30-Day Money Back Guarantee — Zero Risk</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}